const MuiTimelineOppositeContent = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.text.secondary
    })
  }
};
export {
  MuiTimelineOppositeContent
};
//# sourceMappingURL=MuiTimelineOppositeContent.js.map
